var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSun = function SvgSun(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sun_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 3.75V1.5a.75.75 0 1 1 1.5 0v2.25a.75.75 0 1 1-1.5 0M18 12a6 6 0 1 1-6-6 6.006 6.006 0 0 1 6 6m-1.5 0a4.5 4.5 0 1 0-9 0 4.5 4.5 0 0 0 9 0M5.47 6.53a.75.75 0 1 0 1.06-1.06l-1.5-1.5a.75.75 0 1 0-1.06 1.06zm0 10.94-1.5 1.5a.75.75 0 1 0 1.06 1.06l1.5-1.5a.751.751 0 0 0-1.06-1.06M18 6.75a.75.75 0 0 0 .53-.22l1.5-1.5a.75.75 0 1 0-1.06-1.06l-1.5 1.5A.75.75 0 0 0 18 6.75m.53 10.72a.75.75 0 1 0-1.06 1.06l1.5 1.5a.75.75 0 1 0 1.06-1.06zM4.5 12a.75.75 0 0 0-.75-.75H1.5a.75.75 0 1 0 0 1.5h2.25A.75.75 0 0 0 4.5 12m7.5 7.5a.75.75 0 0 0-.75.75v2.25a.75.75 0 1 0 1.5 0v-2.25a.75.75 0 0 0-.75-.75m10.5-8.25h-2.25a.75.75 0 1 0 0 1.5h2.25a.75.75 0 1 0 0-1.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sun_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgSun;